import React, { useEffect, useState } from 'react';
import styles from '@/components/IntegrationExport/EmailCard/styles';
import { TextField, Button, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { adminSetTmsMailInfoAutobook, SaveApiResMessage } from '@/actions';
import { FormControl } from '@material-ui/core';

export default ({ selectedCompany, DATA }) => {
  const cls = styles();
  const [state, setState] = useState({
    tms_mail_subject: '',
    tms_mail_subject_contain: null,
    tms_mail_address: '',
    tms_manual_alias: '',
  });
  const getValue = (primaryKey, fallback = '') => {
    if (DATA?.[primaryKey] !== undefined && DATA?.[primaryKey] !== null) {
      return DATA[primaryKey];
    }
    return fallback;
  };

  const handleSendForm = () => {
    let apiData = {
      tms_mail_subject: state.tms_mail_subject,
      tms_mail_address: state.tms_mail_address,
    };
    if (state.tms_mail_subject_contain) {
      apiData.tms_mail_subject_contain =
        state.tms_mail_subject_contain === 'Contain' ? 1 : 0;
    }
    if (state.tms_manual_alias) {
      apiData.tms_manual_alias = state.tms_manual_alias;
    }
    adminSetTmsMailInfoAutobook(apiData, selectedCompany.value).then((data) => {
      SaveApiResMessage({
        title: data?.data?.messageHeader,
        message: 'Successfully Saved',
        mode: 'success',
      });
    });
  };

  const handleChangeInput = (name, value) => {
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (DATA) {
      const subjectContain = getValue('tms_mail_subject_contain', null);
      setState({
        tms_mail_subject: getValue('tms_mail_subject', ''),
        tms_mail_address: getValue('tms_mail_address', ''),
        tms_manual_alias: getValue('tms_manual_alias', ''),
        tms_mail_subject_contain:
          subjectContain === 0 || subjectContain === 1
            ? subjectContain === 1
              ? 'Contain'
              : 'Exact'
            : null,
      });
    }
  }, [DATA]);

  return (
    <div className={cls.card}>
      <div className={cls.popup}>
        <div className={cls.popupCard}>
          <div className={cls.inputContainer}>
            <span>From:</span>
            <TextField
              type="text"
              placeholder="From"
              className={cls.input}
              InputProps={{ disableUnderline: true }}
              inputProps={{ min: 0 }}
              value={state.tms_mail_address}
              onChange={(e) =>
                handleChangeInput('tms_mail_address', e.target.value)
              }
            />
          </div>
          <div className={cls.inputContainer}>
            <span>Subject:</span>
            <TextField
              type="text"
              placeholder="Subject"
              className={cls.input}
              InputProps={{ disableUnderline: true }}
              inputProps={{ min: 0 }}
              value={state.tms_mail_subject}
              onChange={(e) =>
                handleChangeInput('tms_mail_subject', e.target.value)
              }
            />
          </div>
          <div>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={state.tms_mail_subject_contain}
                className={cls.mailCheck}
                onChange={(e) => {
                  setState((prev) => ({
                    ...prev,
                    tms_mail_subject_contain: e.target.value,
                  }));
                }}>
                <FormControlLabel value={'Contain'} control={<Radio />} label={'Contain'} />
                <FormControlLabel value={'Exact'} control={<Radio />} label={'Exact'} />
              </RadioGroup>
            </FormControl>
          </div>
          <div style={{ marginTop: '20px' }}>
            <div className={cls.inputContainer}>
              <span>TMS Alias:</span>
              <div className={cls.inputContainer}>
                <TextField
                  type="text"
                  placeholder="TMS Alias"
                  className={cls.input}
                  InputProps={{ disableUnderline: true }}
                  value={state.tms_manual_alias}
                  onChange={(e) =>
                    handleChangeInput('tms_manual_alias', e.target.value)
                  }
                />
              </div>
            </div>
          </div>
          <div className={cls.btnContainer}>
            <Button onClick={() => handleSendForm()}>Save</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
